import React, { type FC, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Text, colors } from '@soluto-private/mx-asurion-ui-react';

import {
  useIsLargeDesktop,
  useIsMediumDesktop,
  useIsMobile,
} from '@service-initiation/shared-ui-breakpoints';

const Container = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-top: 16px;
    `};
`;

type Props = {
  style?: React.CSSProperties;
  subtitle?: React.ReactNode;
  title: React.ReactNode;
};

const getTitleSize = (isMediumDesktop: boolean, isLargeDesktop: boolean) => {
  return isMediumDesktop || isLargeDesktop ? 6 : 5;
};

export const getSubTitleSize = (
  isMediumDesktop: boolean,
  isLargeDesktop: boolean
) => {
  return isMediumDesktop || isLargeDesktop ? 4 : 2;
};

export const StepTitle: FC<Props> = ({
  subtitle: Subtitle,
  title,
  ...props
}) => {
  const isLargeDesktop = useIsLargeDesktop();
  const isMediumDesktop = useIsMediumDesktop();
  const isMobile = useIsMobile();
  const titleSize = useMemo(
    () => getTitleSize(isMediumDesktop, isLargeDesktop),
    [isMediumDesktop, isLargeDesktop]
  );
  const subTitleSize = useMemo(
    () => getSubTitleSize(isMediumDesktop, isLargeDesktop),
    [isMediumDesktop, isLargeDesktop]
  );

  return (
    <Container isMobile={isMobile} {...props}>
      <Text
        as="h1"
        data-testid="step-title"
        size={titleSize}
        style={{ marginBottom: '4px' }}
        weight="feather"
      >
        {title}
      </Text>
      {Subtitle && (
        <Text
          as="h2"
          color={colors.neutralDeeper}
          data-testid="step-subtitle"
          size={subTitleSize}
          style={{ marginBottom: '24px' }}
        >
          {Subtitle}
        </Text>
      )}
    </Container>
  );
};
